<template>
  <div class="bb-sales">
    <h2 class="bb-page-title">Sales & CRM</h2>
    <button class="bb-sales__button bb-button" @click="routeContacts">CRM</button>
  </div>
</template>

<script>
export default {
  name: 'DisseminationSales',
  methods: {
    routeContacts () {
      this.$router.push({name: 'ContactsList'})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/_variables";

  .bb-sales {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__button {
      min-width: 102px;
      padding: 0 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/Sales.vue